export const SESSION_WORK_ROUTE = '/session-work';

export const SESSION_WORK_MILESTONES = Object.freeze([
  100_000,
  110_000,
  120_000,
  130_000,
  140_000,
  150_000,
  200_000,
]);

export const SESSION_WORK_ACTIONS = Object.freeze({
  SUMMARY: 'getSessionWorkMilestonesSummary',
  MILESTONE_BOARD: 'getSessionWorkMilestoneLeaderboard',
});

export const SESSION_WORK_VALUE_KEY = 'sessionWork';
export const SESSION_WORK_UNIT = 'Ft·Lbs';

export const SESSION_WORK_COPY = Object.freeze({
  BRAND_LOCKUP: 'BLACK BOX VR',
  HEADLINE: 'SESSION WORK',
  SUBHEAD: 'Single-session Total Work milestones',
  CTA: 'Climb the ladder',
  PAGE_TITLE: 'Black Box VR — Session Work Milestones',
  PAGE_DESCRIPTION:
    'Hall of fame for the heaviest single sessions. Hit 100K Ft·Lbs in one workout — then chase 110, 120, 130, 140, 150, and 200K.',
  MISSION_TITLE: 'ONE SESSION. MAXIMUM WORK.',
  MISSION_BODY:
    'These boards rank your best single workout — not lifetime totals. Cross each threshold in one session to join that milestone hall of fame.',
  HOW_TITLE: 'HOW IT WORKS',
  HOW_BODY:
    'Complete a workout. Your Total Work for that session is compared to your personal best. Cross a milestone and you appear on that board, ranked by your best session.',
  LADDER_TITLE: 'MILESTONE LADDER',
  STANDINGS_TITLE: 'HALL OF FAME',
  EMPTY_TITLE: 'No athletes yet',
  EMPTY_BODY: 'Be the first to hit this threshold in a single session.',
  SOURCE_NOTE: 'Based on finalized sessions at all Black Box VR locations.',
});

export const SESSION_WORK_COLORS = Object.freeze({
  ink: '#0A0B0C',
  charcoal: '#141618',
  panel: '#1A1D20',
  row: '#22262A',
  steel: '#B8BEC4',
  bone: '#F4F1EC',
  copper: '#D48A3A',
  copperDeep: '#A85F1E',
  copperGlow: 'rgba(212, 138, 58, 0.28)',
  ember: '#E85D2A',
  blue: '#0076FF',
  gold: '#E8C547',
  silver: '#A8B0B8',
  bronze: '#C47A3A',
  muted: '#8A9096',
});

export const SESSION_WORK_PODIUM_METALS = Object.freeze([
  { rank: 1, label: 'GOLD', color: SESSION_WORK_COLORS.gold },
  { rank: 2, label: 'SILVER', color: SESSION_WORK_COLORS.silver },
  { rank: 3, label: 'BRONZE', color: SESSION_WORK_COLORS.bronze },
]);
